import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c9c167c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "cm-align-center" }
const _hoisted_3 = { style: {"font-size":"14px"} }

import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { getThemeMode, setThemeMode } from '@/utils/app-theme'
import type { AppThemeMode } from '@/utils/app-theme'
import ThemeModeIcon from './theme-mode-icon.vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'dashboard-theme-mode-toggle',
  props: {
  showLabel: {
    type: Boolean,
    default: false
  },
  size: {
    type: String,
    default: 'small'
  }
},
  setup(__props) {

const props = __props
const btnSize = {
  small: 'btn_tool-small',
  default: 'btn_tool-default'
}[props.size||'small']
/** 主题模式选项：浅色 / 深色 / 跟随系统 */
const THEME_MODE_OPTIONS: { value: AppThemeMode; labelKey: string }[] = [
  { value: 'light', labelKey: 'nav.themeLight' },
  { value: 'dark', labelKey: 'nav.themeDark' },
  { value: 'system', labelKey: 'nav.themeSystem' },
]

const { t } = useI18n()
const currentThemeMode = ref<AppThemeMode>(getThemeMode())
const themeModeOptions = computed(() => THEME_MODE_OPTIONS.map(opt => ({
  value: opt.value,
  label: t(opt.labelKey),
})))
const THEME_MODE_MAP = computed(() => THEME_MODE_OPTIONS.reduce(
  (acc, { value, labelKey }) => {
    acc[value] = t(labelKey);
    return acc;
  },
  {} as Record<AppThemeMode, string>
))
function handleThemeModeChange(command: string) {
  if (command === 'light' || command === 'dark' || command === 'system') {
    setThemeMode(command)
    currentThemeMode.value = command
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createBlock(_component_el_dropdown, {
    class: "theme-dropdown",
    "popper-class": "theme-dropdown-popper",
    size: "small",
    trigger: "click",
    onCommand: handleThemeModeChange
  }, {
    dropdown: _withCtx(() => [
      _createVNode(_component_el_dropdown_menu, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(themeModeOptions.value, (opt) => {
            return (_openBlock(), _createBlock(_component_el_dropdown_item, {
              key: opt.value,
              command: opt.value,
              class: _normalizeClass({ 'is-active': currentThemeMode.value === opt.value })
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(ThemeModeIcon, {
                    mode: opt.value,
                    class: "theme-mode-option-icon",
                    size: 18,
                    style: {"position":"relative","top":"0"}
                  }, null, 8, ["mode"]),
                  _createElementVNode("div", _hoisted_3, _toDisplayString(opt.label), 1)
                ])
              ]),
              _: 2
            }, 1032, ["command", "class"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["theme-toggle-trigger btn_tool", [{ 'has-label': __props.showLabel },_unref(btnSize)]]),
        title: _ctx.$t('nav.themeSwitchTitle') + '(' + THEME_MODE_MAP.value[currentThemeMode.value] + ')'
      }, [
        _createVNode(ThemeModeIcon, { mode: currentThemeMode.value }, null, 8, ["mode"])
      ], 10, _hoisted_1)
    ]),
    _: 1
  }))
}
}

})